// extracted by mini-css-extract-plugin
export var section = "_4x-1";
export var topNav = "_4x-0";